import { useState, type FormEvent } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { api } from '../lib/api';
import { useOturum } from '../lib/oturum';

/**
 * Giris ekrani — telefon + sifre.
 *
 * Tasarim ilkesi (devir dokumani Bolum 1.4): en buyuk risk DIRENC.
 * "Bununla mi ugrasacagim" dedirtmemek icin ekranda iki alan ve tek buton var.
 * Telefon alani sayisal klavye acar; normalizasyon sunucuda yapilir, yani
 * "0554 178 17 74" da "+905541781774" da calisir.
 */
export function Giris() {
  const { yenile } = useOturum();
  const navigate = useNavigate();
  const [telefon, setTelefon] = useState('');
  const [parola, setParola] = useState('');
  const [hata, setHata] = useState<string | null>(null);
  const [gonderiliyor, setGonderiliyor] = useState(false);

  async function gonder(e: FormEvent) {
    e.preventDefault();
    setHata(null);
    setGonderiliyor(true);
    try {
      await api.post('/auth/giris', { telefon, parola });
      await yenile();
    } catch (err) {
      setHata(err instanceof Error ? err.message : 'Giriş yapılamadı');
    } finally {
      setGonderiliyor(false);
    }
  }

  return (
    <main className="flex min-h-dvh items-center justify-center bg-surface-2 p-4">
      <form
        onSubmit={gonder}
        className="w-full max-w-sm rounded-(--radius-mod) border border-line bg-surface shadow-(--shadow-mod) p-6 shadow-sm"
      >
        <h1 className="text-xl font-semibold text-navy">Mod ERP</h1>
        <p className="mb-6 text-sm text-wait">İskele kurulum ve söküm takibi</p>

        <label className="mb-1 block text-sm font-medium text-ink-2" htmlFor="telefon">
          Telefon
        </label>
        <input
          id="telefon"
          name="telefon"
          type="tel"
          inputMode="numeric"
          autoComplete="username"
          autoFocus
          placeholder="0554 178 17 74"
          value={telefon}
          onChange={(e) => setTelefon(e.target.value)}
          className="num mb-4 w-full rounded-(--radius-mod) border border-line-2 px-3 py-2.5 text-base outline-none focus:border-navy"
        />

        <label className="mb-1 block text-sm font-medium text-ink-2" htmlFor="parola">
          Şifre
        </label>
        <input
          id="parola"
          name="parola"
          type="password"
          autoComplete="current-password"
          value={parola}
          onChange={(e) => setParola(e.target.value)}
          className="mb-4 w-full rounded-(--radius-mod) border border-line-2 px-3 py-2.5 text-base outline-none focus:border-navy"
        />

        {hata && (
          <p role="alert" className="mb-4 rounded-(--radius-mod) bg-crit/10 p-3 text-sm text-crit">
            {hata}
          </p>
        )}

        <button
          type="submit"
          disabled={gonderiliyor || !telefon || !parola}
          className="w-full rounded-(--radius-mod) bg-navy px-4 py-2.5 font-medium text-white disabled:opacity-40"
        >
          {gonderiliyor ? 'Giriş yapılıyor…' : 'Giriş yap'}
        </button>

        {/*
          Kasıtlı olarak DÜĞME DEĞİL, alttaki bağlantı: giriş ekranındaki tek
          eylem "giriş yap" olmalı. İkinci bir düğme, şifresini hatırlayan
          kullanıcıyı da bir an duraksatır.
        */}
        <button
          type="button"
          onClick={() => void navigate({ to: '/sifremi-unuttum' })}
          className="mt-4 block w-full text-center text-sm text-muted underline underline-offset-2 hover:text-navy"
        >
          Şifremi unuttum
        </button>
      </form>
    </main>
  );
}
